
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[group]/[pathname]",
      function () {
        return require("private-next-pages/[group]/[pathname]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[group]/[pathname]"])
      });
    }
  